export const FETCH_ALERT_DETAILS_BY_ALERT_ID =
  'FETCH_ALERT_DETAILS_BY_ALERT_ID';
export const FETCH_ALERT_DETAILS_BY_ALERT_ID_SUCCESS =
  'FETCH_ALERT_DETAILS_BY_ALERT_ID_SUCCESS';
export const FETCH_ALERT_DETAILS_BY_ALERT_ID_FAIL =
  'FETCH_ALERT_DETAILS_BY_ALERT_ID_FAIL';

export const FETCH_WHITELIST_BY_CUSTOMER = 'FETCH_WHITELIST_BY_CUSTOMER';
export const FETCH_WHITELIST_BY_CUSTOMER_SUCCESS =
  'FETCH_WHITELIST_BY_CUSTOMER_SUCCESS';
export const FETCH_WHITELIST_BY_CUSTOMER_FAIL =
  'FETCH_WHITELIST_BY_CUSTOMER_FAIL';

export const UPDATE_WHITELIST_BY_CUSTOMER = 'UPDATE_WHITELIST_BY_CUSTOMER';
export const UPDATE_WHITELIST_BY_CUSTOMER_SUCCESS =
  'UPDATE_WHITELIST_BY_CUSTOMER_SUCCESS';
export const UPDATE_WHITELIST_BY_CUSTOMER_FAIL =
  'UPDATE_WHITELIST_BY_CUSTOMER_FAIL';

export const CHANGE_ALERT_STATUS = 'CHANGE_ALERT_STATUS';
export const CHANGE_ALERT_STATUS_SUCCESS = 'CHANGE_ALERT_STATUS_SUCCESS';
export const CHANGE_ALERT_STATUS_FAIL = 'CHANGE_ALERT_STATUS_FAIL';

export const CHANGE_ALERT_ASSIGN_TO_USER = 'CHANGE_ALERT_ASSIGN_TO_USER';
export const CHANGE_ALERT_ASSIGN_TO_USER_SUCCESS =
  'CHANGE_ALERT_ASSIGN_TO_USER_SUCCESS';
export const CHANGE_ALERT_ASSIGN_TO_USER_FAIL =
  'CHANGE_ALERT_ASSIGN_TO_USER_FAIL';

export const TOGGLE_ALERT_NOTE = 'TOGGLE_ALERT_NOTE';
export const CHANGE_ALERT_ASSIGN_SUCCESS = 'CHANGE_ALERT_ASSIGN_SUCCESS';

export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE';

export const fetchAlertDetailsByAlertId = (alertId) => ({
  type: FETCH_ALERT_DETAILS_BY_ALERT_ID,
  payload: alertId
});

export const fetchAlertDetailsByAlertIdSuccess = (alertDetails) => ({
  type: FETCH_ALERT_DETAILS_BY_ALERT_ID_SUCCESS,
  payload: alertDetails
});

export const fetchAlertDetailsByAlertIdFail = (message) => ({
  type: FETCH_ALERT_DETAILS_BY_ALERT_ID_FAIL,
  payload: { message }
});

export const fetchWhitelistByCustomer = (alertId) => ({
  type: FETCH_WHITELIST_BY_CUSTOMER,
  payload: alertId
});

export const fetchWhitelistByCustomerSuccess = (alertDetails) => ({
  type: FETCH_WHITELIST_BY_CUSTOMER_SUCCESS,
  payload: alertDetails
});

export const fetchWhitelistByCustomerFail = (message) => ({
  type: FETCH_WHITELIST_BY_CUSTOMER_FAIL,
  payload: { message }
});

export const updateWhitelistByCustomer = (whitelistData) => ({
  type: UPDATE_WHITELIST_BY_CUSTOMER,
  payload: whitelistData
});

export const updateWhitelistByCustomerSuccess = () => ({
  type: UPDATE_WHITELIST_BY_CUSTOMER_SUCCESS
});

export const updateWhitelistByCustomerFail = (message) => ({
  type: UPDATE_WHITELIST_BY_CUSTOMER_FAIL,
  payload: { message }
});

export const changeAlertStatus = ({
  alertId,
  status,
  hasAlertActions,
  isCaseAlert
}) => ({
  type: CHANGE_ALERT_STATUS,
  payload: { alertId, status, hasAlertActions, isCaseAlert }
});

export const changeAlertStatusSuccess = () => ({
  type: CHANGE_ALERT_STATUS_SUCCESS
});

export const changeAlertStatusFail = (message) => ({
  type: CHANGE_ALERT_STATUS_FAIL,
  payload: { message }
});

export const changeAlertAssignToUser = ({
  alertId,
  userId,
  hasAlertActions,
  isCaseAlert
}) => ({
  type: CHANGE_ALERT_ASSIGN_TO_USER,
  payload: { alertId, userId, hasAlertActions, isCaseAlert }
});

export const changeAlertAssignToUserSuccess = () => ({
  type: CHANGE_ALERT_ASSIGN_TO_USER_SUCCESS
});

export const changeAlertAssignToUserFail = (message) => ({
  type: CHANGE_ALERT_ASSIGN_TO_USER_FAIL,
  payload: { message }
});

export const toggleALertNote = ({ isOpen }) => ({
  type: TOGGLE_ALERT_NOTE,
  payload: { isOpen }
});

export const changeAlertAssignSuccess = () => ({
  type: CHANGE_ALERT_ASSIGN_SUCCESS
});

export const resetErrorMessage = () => ({
  type: RESET_ERROR_MESSAGE
});
